import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { 
  FaCaretDown, 
  FaHome, 
  FaUpload, 
  FaEye, 
  FaChartBar, 
  FaSignOutAlt,
  FaKey,
  FaChartLine,
  FaSearch
} from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import logo from '../Images/oneworldlogo.jpeg';
import "./Navbar.css";
import { useContext } from "react";
import { AuthContext } from "../Contextapi/ContextApi";


const Navbar = ({ onToggleSidebar }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
const { userRole ,logout} = useContext(AuthContext);




  const toggleSidebar = () => {
    const newCollapsed = !collapsed;
    setCollapsed(newCollapsed);
    onToggleSidebar(newCollapsed);
  };

  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
    }
  };

  const handleProfileClick = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleLogout = () => {
     logout();
    navigate("/");
  };

  const handleChangePassword = () => {
    navigate("/change-password");
    setShowDropdown(false);
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.admin-nav-icon-container')) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

 const menuItems = [
  { path: "/dashboard", icon: FaHome, text: "Dashboard" },

  ...(userRole === "Admin"
    ? [
        { 
          path: "/Viewemployee", 
          icon: FaHome, 
          text: "Employees",
          matchPatterns: ["/Viewemployee", "/addEmployee"]
        }
      ]
    : []
  ),

  { path: "/upload", icon: FaUpload, text: "Upload Application" },

  { 
    path: "/view", 
    icon: FaEye, 
    text: "View Application",
    matchPatterns: ["/view", "/addanalysis", "/viewanalysis"]
  },

  ...(userRole === "Admin"
    ? [{ path: "/report", icon: FaChartBar, text: "Report" }]
    : []
  )
];


  // Function to check if a route is active
  const isRouteActive = (item) => {
    // If the item has specific match patterns, check against them
    if (item.matchPatterns) {
      return item.matchPatterns.some(pattern => 
        location.pathname.startsWith(pattern)
      );
    }
    // Default behavior for other routes
    return location.pathname === item.path;
  };

  return (
    <div className="admin-nav-container">
      <div className="admin-nav-header">
        <div className="admin-nav-header-left">
          <div className={`admin-nav-sidebar-toggle ${collapsed ? 'collapsed' : ''}`} onClick={toggleSidebar}>
            <IoMenu className="toggle-icon" />
          </div>
          &nbsp;&nbsp;
          <img
            src={logo}
            alt="Logo"
            className="admin-nav-company-logo"
            style={{ width: "120px", height: "50px", borderRadius: "8px" }}
          />
        </div>

        <div className="admin-nav-header-right">
          <div className="admin-nav-header-icons">
            <div className="admin-nav-icon-container" onClick={handleProfileClick}>
              <div className="admin-nav-profile">
                <img src="https://i.pravatar.cc/100?img=4" alt="Profile" className="admin-nav-profile-img" />
                <FaCaretDown className="admin-nav-caret-icon" />
              </div>
              {showDropdown && (
                <div className="admin-nav-profile-dropdown">
                  <div className="admin-nav-profile-header">
                    <strong>Admin</strong>
                  </div>
                  <div className="admin-nav-profile-item" onClick={handleChangePassword}>
                    <FaKey className="admin-nav-dropdown-icon" />
                    Change password
                  </div>
                  <div className="admin-nav-profile-item" onClick={handleLogout}>
                    <FaSignOutAlt className="admin-nav-dropdown-icon" />
                    Sign Out
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={`admin-nav-sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="admin-nav-position-sticky">
          <ul className="nav flex-column">
            <li className="admin-nav-item">
              {menuItems.map((item) => {
                const IconComponent = item.icon;
                const isActive = isRouteActive(item);
                
                return (
                  <Link 
                    key={item.path}
                    className={`nav-link ${isActive ? "active" : ""}`} 
                    to={item.path} 
                    onClick={handleNavItemClick}
                  >
                    <IconComponent className="admin-nav-icon" />
                    {!collapsed && <span className="link_text">{item.text}</span>}
                  </Link>
                );
              })}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;